import { useMemo } from "react";
import { getCookie } from "@/utils/cookies";
import { useGetTrainersQuery } from "@/queries/useGetTrainersQuery";
import type { Trainer } from "@/utils/booking";

export const useTrainerList = (idClub: string | null) => {
  const userToken = getCookie("user_token");

  const { data: trainersData } = useGetTrainersQuery(idClub, userToken);

  const listOfTrainers = useMemo<Trainer[]>(() => {
    if (!trainersData) return [];

    const trainersMap = new Map<string, Trainer>();

    trainersData.forEach((data: { id: string; name: string }) => {
      if (!trainersMap.has(data.id)) {
        trainersMap.set(data.id, {
          id: data.id,
          name: data.name,
          club_id: idClub || "",
        });
      }
    });

    return Array.from(trainersMap.values());
  }, [trainersData, idClub]);

  return { listOfTrainers };
};
